export const PROXY_VOTING_TYPES = {
  contested_annual_meeting: {
    abbreviated: "ConAM",
    full: "Contested Annual Meeting",
  },
  contested_special_meeting: {
    abbreviated: "ConSM",
    full: "Contested Special Meeting",
  },
  annual_meeting: { abbreviated: "AM", full: "Annual Meeting" },
  special_meeting: { abbreviated: "SM", full: "Special Meeting" },
  consent_solicitation: { abbreviated: "CS", full: "Consent Solicitation" },
};

export const PROXY_NON_VOTING_TYPES = {
  information_statement: { abbreviated: "IS", full: "Information Statement" },
  summary_prospectus: { abbreviated: "SP", full: "Summary Prospectus" },
  "19_a_notice": { abbreviated: "19A", full: "19-A Notice" },
  annual_report: { abbreviated: "AR", full: "Annual Report" },
  semi_annual_report: { abbreviated: "SAR", full: "Semi-Annual Report" },
};

export const ADDITIONAL_MAILING_TYPES = {
  contesting_party_vote_reminder: {
    abbreviated: "ConVRem",
    full: "Contesting Party Vote Reminder",
  },
  contesting_party_announcement: {
    abbreviated: "ConAnn",
    full: "Contesting Party Announcement",
  },
  contesting_party_informational: {
    abbreviated: "ConInfo",
    full: "Contesting Party Informational",
  },
  informational: { abbreviated: "Info", full: "Informational" },
  vote_reminder: { abbreviated: "VRem", full: "Vote Reminder" },
};

const NOBO_TYPES = {
  proxy_related: {
    abbreviated: "NOBO",
    full: "Non-Objecting Beneficial Owner",
  },
};

const SRA_TYPES = {
  nobo: {
    abbreviated: "Nobo",
    full: "Nobo",
  },
  adhoc: {
    abbreviated: "Adhoc",
    full: "Adhoc",
  },
  voted_shareholders: {
    abbreviated: "Voted Shareholders",
    full: "Voted Shareholders",
  },
  not_voted_shareholders: {
    abbreviated: "Not Voted Shareholders",
    full: "Not Voted Shareholders",
  },
  all_shareholders: {
    abbreviated: "All Shareholders",
    full: "All Shareholders",
  },
};

const VCA_TYPES = {
  exchange_offer: {
    abbreviated: "ExO",
    full: "Exchange Offer",
  },
  odd_lot_offer: {
    abbreviated: "OLO",
    full: "Odd Lot Offer",
  },
  buyback: {
    abbreviated: "BuyB",
    full: "Buyback",
  },
  buyback_auction: {
    abbreviated: "BuyA",
    full: "Buyback Auction",
  },
  offer_to_purchase: {
    abbreviated: "OtP",
    full: "Offer to Purchase",
  },
  offer_to_purchase_auction: {
    abbreviated: "OtPA",
    full: "Offer to Purchase Auction",
  },
  merger_consideration_election: {
    abbreviated: "MwE",
    full: "Merger with Election",
  },
  rights_offer: {
    abbreviated: "RO",
    full: "Rights Offer",
  },
  informational: {
    abbreviated: "Info",
    full: "Informational",
  },
  warrants_exercise: {
    abbreviated: "WAR",
    full: "Warrants Exercise",
  },
};

const BANKRUPTCY_TYPES = {
  informational: {
    abbreviated: "Info",
    full: "Informational",
  },
};

const CLASS_ACTION_TYPES = {
  informational: {
    abbreviated: "Info",
    full: "Informational",
  },
  opt_out: {
    abbreviated: "Opt-Out",
    full: "Opt-Out",
  },
};

const ISSUER_TYPES = {
  corporation: {
    abbreviated: "Corp",
    full: "Corporation",
  },
  investment_trust: {
    abbreviated: "InvTrust",
    full: "Investment Trust",
  },
};

export const VOTE_SOLICITATION_TYPES = {
  vote_reminder: { abbreviated: "Vote Reminder", full: "Vote Reminder" },
};

export const SHAREHOLDER_EVENT_TYPES = {
  company_informational: {
    abbreviated: "Info",
    full: "Company Informational",
  },
  company_survey: { abbreviated: "Survey", full: "Company Survey" },
  activist_firm_informational: {
    abbreviated: "Info",
    full: "Activist Firm Informational",
  },
  activist_firm_survey: {
    abbreviated: "Survey",
    full: "Activist Firm Survey",
  },
};

export const QA_EVENT_TYPES = {
  earnings_call: { abbreviated: "Earnings Call", full: "Earnings Call" },
  investor_day: { abbreviated: "Investor Day", full: "Investor Day" },
  product_launch: { abbreviated: "Product Launch", full: "Product Launch" },
  shareholder_meeting: {
    abbreviated: "Shareholder Meeting",
    full: "Shareholder Meeting",
  },
  webinar: { abbreviated: "Webinar", full: "Webinar" },
};

export const QUESTION_TYPES = {
  retail: { abbreviated: "Retail", full: "Retail" },
  institutional: { abbreviated: "Institutional", full: "Institutional" },
  analyst: { abbreviated: "Analyst", full: "Analyst" },
};

export const ALL_TYPES = {
  ...PROXY_VOTING_TYPES,
  ...PROXY_NON_VOTING_TYPES,
  ...ADDITIONAL_MAILING_TYPES,
  ...NOBO_TYPES,
  ...SRA_TYPES,
  ...VCA_TYPES,
  ...BANKRUPTCY_TYPES,
  ...CLASS_ACTION_TYPES,
  ...ISSUER_TYPES,
  ...VOTE_SOLICITATION_TYPES,
  ...SHAREHOLDER_EVENT_TYPES,
  ...QA_EVENT_TYPES,
  ...QUESTION_TYPES,
};
